// Centralised external links to the public marketing / WordPress site.
//
// The app is served on its own host (app.<domain>); these point at the separate
// marketing site. Keeping them in one place means a domain migration (e.g.
// emdrlink.pl -> emdr.link) is a single change to MARKETING_BASE instead of
// hunting call sites across the app.
const MARKETING_BASE = "https://emdrlink.pl";

/** Build a marketing-site URL from a leading-slash path (e.g. "/cennik"). */
export const marketingUrl = (path = "/"): string => `${MARKETING_BASE}${path}`;

export const EXTERNAL_LINKS = {
    home: marketingUrl("/"),
    about: marketingUrl("/app/"),
    pricing: marketingUrl("/cennik"),
    contact: marketingUrl("/kontakt/"),
    shop: marketingUrl("/sklep/"),
    device: marketingUrl("/neuro-tapper/"),
    findTherapist: marketingUrl("/znajdz-terapeute/"),
    training: marketingUrl("/szkolenia-online/"),
    advert: marketingUrl("/reklama"),
    programManual: marketingUrl("/wsparcie-techniczne/instrukcja-programu-emdr-online/"),
    deviceManual: marketingUrl("/wsparcie-techniczne/instrukcja-obslugi-tappera/"),
    // WordPress customer profile — used if/when profile editing moves to WordPress.
    customerProfile: marketingUrl("/konto-klienta/profile/"),
    privacyPolicy: marketingUrl("/polityka-prywatnosci/"),
    cookiePolicy: marketingUrl("/polityka-cookies/"),
};

// Social profiles live on their own platforms, not the marketing domain.
export const SOCIAL_LINKS = {
    facebook: "https://www.facebook.com/emdrlink",
    instagram: "https://www.instagram.com/emdrlink/",
};
